'use strict';
import { combineReducers, createStore, applyMiddleware } from 'redux';
import { itemsReducer } from './reducers/items';
import { categoryReducer } from './reducers/categories';
import { userReducer } from './reducers/users';
import { userReducer as merchantReducer } from './reducers/users';
import { userReducer as subAccountReducer } from './reducers/users';
import { userReducer as currentUserReducer } from './reducers/users';
import { emptyReducer } from './reducers/empty';
import { panelsReducer } from './reducers/panels';
import { purchaseReducer } from './reducers/purchases';
import { settingsReducer } from './reducers/settings';
import { orderReducer } from './reducers/orders';
import { inboxReducer } from './reducers/inbox';
import { searchReducer } from './reducers/search';
import { orderDiaryReducer } from './reducers/order-diary';
import { dashboardReducer } from './reducers/dashboard';
import { comparisonReducer } from './reducers/comparisons';
import { uploadEditItemReducer } from './reducers/uploadEditItem';
import { activityLogReducer } from './reducers/activitylog';
import { marketplaceReducer } from './reducers/marketplaces';
import { deliverySettingsReducer } from './reducers/delivery-settings';
import { contentPageReducer } from './reducers/content-pages';
import { contentPageReducer as policyReducer } from './reducers/content-pages';
import { chatReducer } from './reducers/chat';
import { cartReducer } from './reducers/carts';
import { checkoutReducer } from './reducers/checkout';
import { approvalReducer } from './reducers/approval';
import { quotationReducer } from './reducers/quotations';
import { requisitionReducer } from './reducers/requisitions';
import { recevingNoteReducer as receivingNoteReducer } from './reducers/receiving-notes';
import { invoiceReducer } from './reducers/invoice';
import { userGroupReducer } from './reducers/user-groups';
import { accountPermissionReducer } from './reducers/account-permissions';
import { blogReducer } from './reducers/blog';
import { wishlistReducer } from './reducers/wishlist';
import thunk from 'redux-thunk';

const headerReducers = {
    categoryReducer,
    userReducer,
    panelsReducer,
    marketplaceReducer,
    inboxReducer,
    cartReducer
};

const headerReducer = combineReducers(headerReducers);

const bundleReducer = combineReducers({
    ...headerReducers,
    itemsReducer
});

const sidebarReducer = combineReducers({
    ...headerReducers,
    userReducer,
    marketplaceReducer,
    approvalReducer
});

const homepageReducer = combineReducers({
    ...headerReducers,
    itemsReducer,
    categoryReducer,
    userReducer,
    panelsReducer,
    settingsReducer
});

const itemDetailReducer = combineReducers({
    ...headerReducers,
    itemsReducer,
    userReducer,
    panelsReducer,
    merchantReducer,
    comparisonReducer,
    marketplaceReducer,
    cartReducer
});

const purchasePageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    purchaseReducer,
    orderDiaryReducer,
    comparisonReducer,
    marketplaceReducer
});

const storeFrontPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    itemsReducer,
    merchantReducer
});

const orderPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    orderReducer,
    orderDiaryReducer,
    marketplaceReducer
});

const inboxPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    inboxReducer
});

const ActivityLogPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    activityLogReducer
});

const ComparisonPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    comparisonReducer
});

const settingPageReducer = combineReducers({
    ...headerReducers,
    settingsReducer,
    userReducer,
    currentUserReducer,
    inboxReducer
});

const searchPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    categoryReducer,
    searchReducer
});

const checkoutReviewPageReducer = combineReducers({
    ...headerReducers,
    settingsReducer,
    merchantReducer,
    userReducer
});

const dashboardComponentReducer = combineReducers({
    ...headerReducers,
    dashboardReducer,
    userReducer
});

const itemUploadEditReducer = combineReducers({
    ...headerReducers,
    uploadEditItemReducer,
    userReducer
});

const deliverySettingsReducerCombineReducer = combineReducers({
    ...headerReducers,
    deliverySettingsReducer,
    userReducer
});

const footerReducer = combineReducers({
    ...headerReducers,
    panelsReducer,
    contentPageReducer,
    marketplaceReducer
});

const itemListPageReducer = combineReducers({
    ...headerReducers,
    itemsReducer,
    userReducer
});

const subAccountPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    subAccountReducer,
    marketplaceReducer
});

const policyPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    policyReducer
});

const chatPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    chatReducer,
    comparisonReducer
});

const cartPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    cartReducer,
    marketplaceReducer
});

const checkoutPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    checkoutReducer
});

const OnePageCheckoutReducer = combineReducers({
    ...headerReducers,
    settingsReducer,
    merchantReducer,
    checkoutReducer,
    userReducer,
    currentUserReducer,
    marketplaceReducer
});

const approvalPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    approvalReducer
});

const QuotationPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    quotationReducer
});

const RequisitionPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    requisitionReducer,
    orderDiaryReducer,
    marketplaceReducer
});

const ReceivingNotePageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    receivingNoteReducer,
    orderDiaryReducer,
    marketplaceReducer
});

const InvoicePageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    invoiceReducer,
    orderDiaryReducer,
    marketplaceReducer
});

const UserGroupPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    userGroupReducer
});

const AccountPermissionPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    accountPermissionReducer
});

const UnauthorizedAccessPageReducer = combineReducers({
    ...headerReducers,
    userReducer
});

const blogPageReducer = combineReducers({
    ...headerReducers,
    userReducer,
    blogReducer,
    categoryReducer,
    panelsReducer
});

const WishlistReducer = combineReducers({
    ...headerReducers,
    userReducer,
    wishlistReducer
});

const onboardingPageReducer = combineReducers({
    ...headerReducers,
    userReducer
});

function createBundleStore(initialState) {
    return createStore(bundleReducer, initialState, applyMiddleware(thunk));
}

function createOnboardingStore(initialState) {
    return createStore(onboardingPageReducer, initialState, applyMiddleware(thunk));
}

function createDeliverySettingsStore(initialState) {
    return createStore(deliverySettingsReducerCombineReducer, initialState, applyMiddleware(thunk));
}

function createHeaderStore(initialState) {
    return createStore(headerReducer, initialState, applyMiddleware(thunk));
}

function createSidebarStore(initialState) {
    return createStore(sidebarReducer, initialState, applyMiddleware(thunk));
}

function createHomepageStore(initialState) {
    return createStore(homepageReducer, initialState, applyMiddleware(thunk));
}

function createEmptyStore(initialState) {
    return createStore(emptyReducer, initialState, applyMiddleware(thunk));
}

function createItemDetailStore(initialState) {
    return createStore(itemDetailReducer, initialState, applyMiddleware(thunk));
}

function createPurchaseStore(initialState) {
    return createStore(purchasePageReducer, initialState, applyMiddleware(thunk));
}

function createSettingsStore(initialState) {
    return createStore(settingPageReducer, initialState, applyMiddleware(thunk));
}

function createOrderStore(initialState) {
    return createStore(orderPageReducer, initialState, applyMiddleware(thunk));
}

function createInboxStore(initialState) {
    return createStore(inboxPageReducer, initialState, applyMiddleware(thunk));
}

function createStoreFrontStore(initialState) {
    return createStore(storeFrontPageReducer, initialState, applyMiddleware(thunk));
}

function createSearchStore(initialState) {
    return createStore(searchPageReducer, initialState, applyMiddleware(thunk));
}

function checkoutReviewPageStore(initialState) {
    return createStore(checkoutReviewPageReducer, initialState, applyMiddleware(thunk));
}

function checkoutTransactionCompletePageStore(initialState) {
    return createStore(settingPageReducer, initialState, applyMiddleware(thunk));
}

function createDashboardStore(initialState) {
    return createStore(dashboardComponentReducer, initialState, applyMiddleware(thunk));
}

function createItemUploadEditStore(initialState) {
    return createStore(itemUploadEditReducer, initialState, applyMiddleware(thunk));
}

function createComparisonStore(initialState) {
    return createStore(ComparisonPageReducer, initialState, applyMiddleware(thunk));
}

function createActivityLogStore(initialState) {
    return createStore(ActivityLogPageReducer, initialState, applyMiddleware(thunk));
}

function createFooterStore(initialState) {
    return createStore(footerReducer, initialState, applyMiddleware(thunk));
}

function createItemListStore(initialState) {
    return createStore(itemListPageReducer, initialState, applyMiddleware(thunk));
}

function createSubAccountStore(initialState) {
    return createStore(subAccountPageReducer, initialState, applyMiddleware(thunk));
}

function createPolicyStore(initialState) {
    return createStore(policyPageReducer, initialState, applyMiddleware(thunk));
}

function createChatStore(initialState) {
    return createStore(chatPageReducer, initialState, applyMiddleware(thunk));
}

function createApprovalStore(initialState) {
    return createStore(approvalPageReducer, initialState, applyMiddleware(thunk));
}

function createCartStore(initialState) {
    return createStore(cartPageReducer, initialState, applyMiddleware(thunk));
}

function createCheckoutStore(initialState) {
    return createStore(checkoutPageReducer, initialState, applyMiddleware(thunk));
}

function createOnePageCheckoutStore(initialState) {
    return createStore(OnePageCheckoutReducer, initialState, applyMiddleware(thunk));
}

function createQuotationStore(initialState) {
    return createStore(QuotationPageReducer, initialState, applyMiddleware(thunk));
}

function createRequisitionStore(initialState) {
    return createStore(RequisitionPageReducer, initialState, applyMiddleware(thunk));
}

function createReceivingNoteStore(initialState) {
    return createStore(ReceivingNotePageReducer, initialState, applyMiddleware(thunk));
}

function createInvoiceStore(initialState) {
    return createStore(InvoicePageReducer, initialState, applyMiddleware(thunk));
}

function createUserGroupStore(initialState) {
    return createStore(UserGroupPageReducer, initialState, applyMiddleware(thunk));
}

function createAccountPermissionStore(initialState) {
    return createStore(AccountPermissionPageReducer, initialState, applyMiddleware(thunk));
}

function createUnauthorizedAccessStore(initialState) {
    return createStore(UnauthorizedAccessPageReducer, initialState, applyMiddleware(thunk));
}

function createBlogStore(initialState) {
    return createStore(blogPageReducer, initialState, applyMiddleware(thunk));
}

function createWishlistStore(initialState) {
    return createStore(WishlistReducer, initialState, applyMiddleware(thunk));
}

export { createHomepageStore, createHeaderStore, createSidebarStore, createEmptyStore, createItemDetailStore, createPurchaseStore, createSettingsStore, createOrderStore, createInboxStore, createStoreFrontStore, createSearchStore, checkoutReviewPageStore, checkoutTransactionCompletePageStore, createDashboardStore, createItemUploadEditStore, createActivityLogStore, createApprovalStore, createComparisonStore, createFooterStore, createDeliverySettingsStore, createItemListStore, createSubAccountStore, createPolicyStore, createChatStore, createCartStore, createCheckoutStore, createOnePageCheckoutStore, createQuotationStore, createRequisitionStore, createReceivingNoteStore, createInvoiceStore, createUserGroupStore, createAccountPermissionStore, createUnauthorizedAccessStore, createBlogStore, createWishlistStore, createOnboardingStore, createBundleStore };

export default {
    createHomepageStore: createHomepageStore,
    createHeaderStore: createHeaderStore,
    createSidebarStore: createSidebarStore,
    createEmptyStore: createEmptyStore,
    createItemDetailStore: createItemDetailStore,
    createPurchaseStore: createPurchaseStore,
    createSettingsStore: createSettingsStore,
    createOrderStore: createOrderStore,
    createInboxStore: createInboxStore,
    createStoreFrontStore: createStoreFrontStore,
    createSearchStore: createSearchStore,
    checkoutReviewPageStore: checkoutReviewPageStore,
    checkoutTransactionCompletePageStore: checkoutTransactionCompletePageStore,
    createDashboardStore: createDashboardStore,
    createItemUploadEditStore: createItemUploadEditStore,
    createActivityLogStore: createActivityLogStore,
    createApprovalStore: createApprovalStore,
    createComparisonStore: createComparisonStore,
    createFooterStore: createFooterStore,
    createDeliverySettingsStore: createDeliverySettingsStore,
    createItemListStore: createItemListStore,
    createSubAccountStore: createSubAccountStore,
    createPolicyStore: createPolicyStore,
    createChatStore: createChatStore,
    createCartStore: createCartStore,
    createCheckoutStore: createCheckoutStore,
    createOnePageCheckoutStore: createOnePageCheckoutStore,
    createQuotationStore: createQuotationStore,
    createRequisitionStore: createRequisitionStore,
    createReceivingNoteStore: createReceivingNoteStore,
    createInvoiceStore: createInvoiceStore,
    createUserGroupStore: createUserGroupStore,
    createAccountPermissionStore: createAccountPermissionStore,
    createUnauthorizedAccessStore: createUnauthorizedAccessStore,
    createBlogStore: createBlogStore,
    createWishlistStore: createWishlistStore,
    createOnboardingStore: createOnboardingStore,
    createBundleStore: createBundleStore
};
